const DOCUMENT = 'JOB_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  DELETE: DOCUMENT + 'DELETE',
  DELETE_SUCCESS: DOCUMENT + 'DELETE_SUCCESS',
  EDIT: DOCUMENT + 'EDIT',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CHANGE_PROPERTIES: DOCUMENT + 'CHANGE_PROPERTIES',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  CANCEL: DOCUMENT + 'CANCEL',
  TOUCH: DOCUMENT + 'TOUCH',
  GET_LOCATION: DOCUMENT + 'GET_LOCATION',
  APPROVE_JOB_REQUEST: DOCUMENT + 'APPROVE_JOB_REQUEST',
  RECEIVE_PAUSE_REASONS: DOCUMENT + 'RECEIVE_PAUSE_REASONS',
  GET_PAUSE_REASONS: DOCUMENT + 'GET_PAUSE_REASONS',
  CHANGE_REASONS: DOCUMENT + 'CHANGE_REASONS',
  CHANGE_REASONS_COMMENT: DOCUMENT + 'CHANGE_REASONS_COMMENT',
  PAUSE_MA_REQUEST: DOCUMENT + 'PAUSE_MA_REQUEST',
  ON_PAUSE_MA: DOCUMENT + 'ON_PAUSE_MA',
  UPDATE_PAUSE_MA_ACTION: DOCUMENT + 'UPDATE_PAUSE_MA_ACTION',
  UPDATE_RESUME_MA_ACTION: DOCUMENT + 'UPDATE_RESUME_MA_ACTION',
  RESUME_MA_REQUEST: DOCUMENT + 'RESUME_MA_REQUEST',
  SEND_REQUEST: DOCUMENT + 'SEND_REQUEST',
  SHOW_MODAL: DOCUMENT + 'SHOW_MODAL',
  CLOSE_MODAL: DOCUMENT + 'CLOSE_MODAL',
  SHOW_JOB_MODAL: DOCUMENT + 'SHOW_JOB_MODAL',
  CLOSE_JOB_MODAL: DOCUMENT + 'CLOSE_JOB_MODAL',
  TOGGLE_ADD_GIG_MODAL: DOCUMENT + 'TOGGLE_ADD_GIG_MODAL',
  GET_ROSTERS: DOCUMENT + 'GET_ROSTERS',
  TOGGLE_ADD_OTHER_PAYMENTS_MODAL: DOCUMENT + 'TOGGLE_ADD_OTHER_PAYMENTS_MODAL',
  TOGGLE_SHOW_MORE: DOCUMENT + 'TOGGLE_SHOW_MORE',
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  LOAD_SHIFTS: DOCUMENT + 'LOAD_SHIFTS',
  LOAD_SHIFTS_SUCCESS: DOCUMENT + 'LOAD_SHIFTS_SUCCESS',
  LOAD_CANCELLED_SHIFTS: DOCUMENT + 'LOAD_CANCELLED_SHIFTS',
  LOAD_CANCELLED_SHIFTS_SUCCESS: DOCUMENT + 'LOAD_CANCELLED_SHIFTS_SUCCESS',
  LOAD_BACKUP_SHIFTS: DOCUMENT + 'LOAD_BACKUP_SHIFTS',
  LOAD_BACKUP_SHIFTS_SUCCESS: DOCUMENT + 'LOAD_BACKUP_SHIFTS_SUCCESS',
  LOAD_REPORTED_SHIFTS: DOCUMENT + 'LOAD_REPORTED_SHIFTS',
  LOAD_REPORTED_SHIFTS_SUCCESS: DOCUMENT + 'LOAD_REPORTED_SHIFTS_SUCCESS',
  SHOW_ACCREDITATION_SUMMARY_MODAL: DOCUMENT + 'SHOW_ACCREDITATION_SUMMARY_MODAL',
  HIDE_ACCREDITATION_SUMMARY_MODAL: DOCUMENT + 'HIDE_ACCREDITATION_SUMMARY_MODAL',
  REOPEN_POOLS_REQUEST: DOCUMENT + 'REOPEN_POOLS_REQUEST',
  REOPEN_POOLS_SUCCESS: DOCUMENT + 'REOPEN_POOLS_SUCCESS',
  REOPEN_POOLS_ERROR: DOCUMENT + 'REOPEN_POOLS_ERROR',
  SHOW_CONSOLIDATED_INVOICE_REQUEST: DOCUMENT + 'SHOW_CONSOLIDATED_INVOICE_REQUEST',
  SHOW_CONSOLIDATED_INVOICE_SUCCESS: DOCUMENT + 'SHOW_CONSOLIDATED_INVOICE_SUCCESS',
  SHOW_CONSOLIDATED_INVOICE_ERROR: DOCUMENT + 'SHOW_CONSOLIDATED_INVOICE_ERROR',
  LOAD_WORKER_SUBMISSIONS_REQUEST: DOCUMENT + 'LOAD_WORKER_SUBMISSIONS_REQUEST',
  LOAD_WORKER_SUBMISSIONS_SUCCESS: DOCUMENT + 'LOAD_WORKER_SUBMISSIONS_SUCCESS',
  LOAD_APPROVED_AFTER_JOB_CLOSED_REQUEST: DOCUMENT + 'LOAD_APPROVED_AFTER_JOB_CLOSED_REQUEST',
  LOAD_APPROVED_AFTER_JOB_CLOSED_SUCCESS: DOCUMENT + 'LOAD_APPROVED_AFTER_JOB_CLOSED_SUCCESS',
  CLEAR_CONSOLIDATED_INVOICE_MODAL: DOCUMENT + 'CLEAR_CONSOLIDATED_INVOICE_MODAL',

  reopenPools: data => ({
    type: actions.REOPEN_POOLS_REQUEST,
    payload: data,
  }),

  reopenPoolsSuccess: () => ({
    type: actions.REOPEN_POOLS_SUCCESS,
  }),

  reopenPoolsError: () => ({
    type: actions.REOPEN_POOLS_ERROR,
  }),

  loadWorkerSubmissionsRequest: data => ({
    type: actions.LOAD_WORKER_SUBMISSIONS_REQUEST,
    payload: data,
  }),

  loadWorkerSubmissionsSuccess: data => ({
    type: actions.LOAD_WORKER_SUBMISSIONS_SUCCESS,
    payload: data,
  }),

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadShifts: data => ({
    type: actions.LOAD_SHIFTS,
    payload: data,
  }),

  loadShiftsSuccess: data => ({
    type: actions.LOAD_SHIFTS_SUCCESS,
    payload: data,
  }),

  loadApprovedAfterJobClosedRequest: data => ({
    type: actions.LOAD_APPROVED_AFTER_JOB_CLOSED_REQUEST,
    payload: data,
  }),

  loadApprovedAfterJobClosedSuccess: data => ({
    type: actions.LOAD_APPROVED_AFTER_JOB_CLOSED_SUCCESS,
    payload: data,
  }),

  loadCancelledShifts: data => ({
    type: actions.LOAD_CANCELLED_SHIFTS,
    payload: data,
  }),

  loadCancelledShiftsSuccess: data => ({
    type: actions.LOAD_CANCELLED_SHIFTS_SUCCESS,
    payload: data,
  }),

  loadBackupShifts: data => ({
    type: actions.LOAD_BACKUP_SHIFTS,
    payload: data,
  }),

  loadReportedShifts: data => ({
    type: actions.LOAD_REPORTED_SHIFTS,
    payload: data,
  }),

  loadBackupShiftsSuccess: data => ({
    type: actions.LOAD_BACKUP_SHIFTS_SUCCESS,
    payload: data,
  }),

  loadReportedShiftsSuccess: data => ({
    type: actions.LOAD_REPORTED_SHIFTS_SUCCESS,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  delete: data => ({
    type: actions.DELETE,
    payload: data,
  }),

  deleteSuccess: () => ({
    type: actions.DELETE_SUCCESS,
  }),

  edit: data => ({
    type: actions.EDIT,
    payload: data,
  }),

  save: data => ({
    type: actions.SAVE,
    payload: data,
  }),

  saveSuccess: data => ({
    type: actions.SAVE_SUCCESS,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  changeProperties: data => ({
    type: actions.CHANGE_PROPERTIES,
    payload: data,
  }),

  cancel: () => ({
    type: actions.CANCEL,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),

  getLocation: data => ({
    type: actions.GET_LOCATION,
    payload: data,
  }),

  getPauseReasonsRequest: data => ({
    type: actions.GET_PAUSE_REASONS,
    payload: data,
  }),

  getPauseReasons: data => ({
    type: actions.RECEIVE_PAUSE_REASONS,
    payload: data,
  }),

  changeReason: data => ({
    type: actions.CHANGE_REASONS,
    payload: data,
  }),

  changeReasonComment: data => ({
    type: actions.CHANGE_REASONS_COMMENT,
    payload: data,
  }),

  pauseMaRequest: data => ({
    type: actions.PAUSE_MA_REQUEST,
    payload: data,
  }),

  onMaCall: data => ({
    type: actions.ON_PAUSE_MA,
    payload: data,
  }),

  resumeMaRequest: data => ({
    type: actions.RESUME_MA_REQUEST,
    payload: data,
  }),

  updatePauseMaAction: data => ({
    type: actions.UPDATE_PAUSE_MA_ACTION,
    payload: data,
  }),

  updateResumeMaAction: data => ({
    type: actions.UPDATE_RESUME_MA_ACTION,
    payload: data,
  }),

  sendRequest: data => ({
    type: actions.SEND_REQUEST,
    payload: data,
  }),

  toggleAddOtherPaymentsModal: () => ({
    type: actions.TOGGLE_ADD_OTHER_PAYMENTS_MODAL,
  }),

  showModal: data => ({
    type: actions.SHOW_MODAL,
    payload: data,
  }),

  toggleAddGigModal: () => ({
    type: actions.TOGGLE_ADD_GIG_MODAL,
  }),

  showJobModal: data => ({
    type: actions.SHOW_JOB_MODAL,
    payload: data,
  }),

  closeJobModal: () => ({
    type: actions.CLOSE_JOB_MODAL,
  }),

  closeModal: () => ({
    type: actions.CLOSE_MODAL,
  }),

  getRosters: data => ({
    type: actions.GET_ROSTERS,
    payload: data,
  }),

  toggleShowMore: () => ({
    type: actions.TOGGLE_SHOW_MORE,
  }),

  addNotification: data => {
    const id = new Date().getTime();

    return {
      type: actions.ADD_NOTIFICATION,
      payload: { ...data, id },
    };
  },

  approveJob: data => ({
    type: actions.APPROVE_JOB_REQUEST,
    payload: data,
  }),

  showAccreditationSummaryModal: () => ({
    type: actions.SHOW_ACCREDITATION_SUMMARY_MODAL,
  }),

  hideAccreditationSummaryModal: () => ({
    type: actions.HIDE_ACCREDITATION_SUMMARY_MODAL,
  }),

  showConsolidatedInvoiceRequest: data => ({
    type: actions.SHOW_CONSOLIDATED_INVOICE_REQUEST,
    payload: data,
  }),

  showConsolidatedInvoiceSuccess: data => ({
    type: actions.SHOW_CONSOLIDATED_INVOICE_SUCCESS,
    payload: data,
  }),

  showConsolidatedInvoiceError: () => ({
    type: actions.SHOW_CONSOLIDATED_INVOICE_ERROR,
  }),

  clearConsolidatedInvoiceModal: () => ({
    type: actions.CLEAR_CONSOLIDATED_INVOICE_MODAL,
  }),
};

export default actions;
